import React from "react";
import BusinessInformation from "./BusinessInformation";
import PersonalInformation from "./PersonalInformation";
import BusinessProfile from "./BusinessProfile";
import CreditCardProcessing from "./CreditCardProcessing";
import BillingPreferences from "./BillingPreferences";
import Pricing from "./Pricing";
import Equipment from "./Equipment";
import VarOnly from "./VarOnly";
import PartnerPricing from "./PartnerPricing";
import Underwriting from "./Underwriting";
import VapeAttestation from "./VapeAttestation";
import TravelAddendum from "./TravelAddendum";
import { conditionalAddendums } from "../../../../../constants";

function MerchantDetails({ appData }) {
  const vapeAttestationData = appData?.powerapp_addendum?.find(
    (addendum) => addendum?.addendum === conditionalAddendums.VAPE_ATTESTATION,
  );
  const travelAddendumData = appData?.powerapp_addendum?.find(
    (addendum) => addendum?.addendum === conditionalAddendums.TRAVEL_ADDENDUM,
  );

  return (
    <div>
      <BusinessInformation appData={appData} />
      <PersonalInformation appData={appData} />
      <BusinessProfile appData={appData} />
      <CreditCardProcessing appData={appData} />
      <BillingPreferences appData={appData} />
      {vapeAttestationData && (
        <VapeAttestation vapeAttestationData={vapeAttestationData} />
      )}
      {travelAddendumData && (
        <TravelAddendum travelAddendumData={travelAddendumData} />
      )}
      {appData?.billing ? (
        <Pricing appData={appData} />
      ) : (
        <PartnerPricing appData={appData} />
      )}
      <Equipment appData={appData} />
      <VarOnly appData={appData} />
      <Underwriting appData={appData} />
    </div>
  );
}

export default MerchantDetails;
